import { useNavigate, useSearch } from '@tanstack/react-router';

import { parseDealsRouteSearch, serializeDealsRouteSearch } from './routeSearch';
import type { DealSortDirection, DealSortProperty, DealStatus } from './model';

export function useDealsRouteFilters() {
  const navigate = useNavigate({ from: '/demand/deals/' });
  const search = useSearch({ from: '/demand/deals/' });
  const filter = parseDealsRouteSearch(search);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeDealsRouteSearch(next), replace: true });
  };
  return {
    filter,
    setSearch(searchTerm: string) {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses(statuses: DealStatus[]) {
      update({ ...filter, statuses, page: 0 });
    },
    setPagination(page: number, size: number) {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
    setSort(sortProperty: DealSortProperty | null, sortDirection: DealSortDirection) {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}
